define('modules/base/models/home.activities.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.paging.model'
], function(_, Backbone, BasePagingModel){
    var HomeActivitiesModel = BasePagingModel.extend({
        initialize: function(options) {
            if(options.type != undefined){
                this.type = options.type;
            } else {
                this.type = "identities";
            }
            this.base += this.type;
        },
        base: 'user/viewed/',
        useLocalStorage: true,
        onlyUseLocalStorageForFirstPull: true
    });
    return HomeActivitiesModel;
});

